export default __webpack_public_path__ + "static/1369-e1b7c56b5a99035a9a2d0aacf441f6d5.gif";